module.exports = __webpack_public_path__ + "static/media/chevron-black.87c80e46.svg";